<template>
  <v-btn
    :depressed="depressed"
    :dark="dark"
    :block="block"
    :color="color"
    :dense="dense"
    :loading="loading"
    @click="$emit('click')"
    :to="to"
    :height="height"
    :disabled="disabled"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    to: {
      type: [String, Object],
      default: null,
    },
    depressed: {
      type: Boolean,
      default: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [String, Number],
      default: "36px",
    },
    color: {
      type: String,
      default: "primary",
    },
  },
};
</script>
